import ScrollManager from "./scroll-manager";

export default ScrollManager;
